module.exports = __webpack_public_path__ + "static/img/huanqiu.397d024b.png";